import React from "react";
import { HeartPulseIcon, TimerIcon, BoxIcon, LayersIcon, MonitorPlayIcon, GiftIcon } from "lucide-react";
type Bonus = {
  icon: BoxIcon;
  title: string;
  value: string;
  description: string;
  imageUrl: string;
};
const bonuses: Bonus[] = [{
  icon: HeartPulseIcon,
  title: 'Special Populations Atlas',
  value: '$25 Value',
  description: 'Teach safer classes for pregnant students, seniors, and sensitive bodies with instant modifications.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/kWZ9L3LWZh6qZGFnyRVVsS/f1a378a5-81a3-45b4-9c55-b2da07089a62-mockup.webp'
}, {
  icon: TimerIcon,
  title: '15-Minute Class Rescue Cards',
  value: '$15 Value',
  description: 'Turn any 60-minute sequence into a 15, 30, or 45-minute polished session when time is tight.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/2DzWkTpkSb7s7ztVDyHxyD/d5d5ad10-b099-4be0-9d10-8f4c9c5f0905-mockup.webp'
}, {
  icon: BoxIcon,
  title: 'Props & Modifications Toolkit',
  value: '$20 Value',
  description: 'Master the use of blocks, straps, and bolsters to create a premium, accessible experience.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/6Z6wxnsQjSyo4FEqNqKsvR/d6f1cafb-b851-4ff6-b454-09204a123501-mockup.webp'
}, {
  icon: LayersIcon,
  title: 'Mixed-Level Control Board',
  value: '$12 Value',
  description: 'Beginner, intermediate, and advanced options to manage any room with total confidence.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/1GPKGer4K6GF9U4ekKEznB/e37470c8-4c57-40fd-bbed-4a19baba18e6-mockup.webp'
}, {
  icon: MonitorPlayIcon,
  title: 'Private & Online Adapter',
  value: '$15 Value',
  description: 'Transform your sequences into high-ticket private sessions or high-quality Zoom classes.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/e6rLrcZxqRetg9TEPd4d2b/f78f23bf-2ff9-4894-9e6a-7869dfbc66e0-mockup.webp'
}];
export function BonusSection() {
  return <section className="bg-[#241622] px-5 py-20" data-id="element-3" data-mp="3h554mozgu3oa">
      <div className="mx-auto max-w-5xl" data-id="element-4" data-mp="3h3tqbv8e9dix">
        <div className="text-center" data-id="element-5" data-mp="1h35ahw3v2rxb">
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-6" data-mp="1h23vjgjq5lab">
            <GiftIcon className="h-4 w-4" data-id="element-7" data-mp="1c42h58x8ua56" /> Included free today
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-8" data-mp="1q2se8ok2c9tj">
            Five strategic <span className="text-emerald-300" data-id="element-9" data-mp="1m0dsnwp0evyk">bonuses</span>
          </h2>
          <p className="mt-4 text-sm font-medium text-slate-300" data-id="element-10" data-mp="ydp4it9eq79i">
            Real bonus-pack value: $87 — included free today with YOGA READY™.
          </p>
        </div>

        <div className="mt-11 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-11" data-mp="175hd0yevf6bg">
          {bonuses.map(({
          icon: Icon,
          title,
          value,
          description,
          imageUrl
        }, index) => <article key={title} className="overflow-hidden border border-emerald-200/20 bg-[#38233c]" data-id="element-12" data-mp="enva07fb5e1l" data-mpi={index}>
              <img src={imageUrl} alt={`Mockup of the ${title} bonus`} width={1024} height={1024} loading="lazy" className="aspect-square w-full object-cover" data-id="element-13" data-mp="am9xwoall3sg" />
              <div className="p-6" data-id="element-14" data-mp="59uubguaddeo">
                <div className="flex items-center justify-between gap-4" data-id="element-15" data-mp="5b67265plvhx">
                  <span className="grid h-11 w-11 place-items-center border border-emerald-300/40 bg-emerald-400/10" data-id="element-16" data-mp="3mr4l83ffmqzy">
                    <Icon className="h-5 w-5 text-emerald-300" data-id="element-17" data-mp="3rqqygcv9g78r" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-18" data-mp="j9mha72s644t">
                    Bonus {String(index + 1).padStart(2, '0')}
                  </p>
                </div>
                <div className="mt-6" data-id="element-19" data-mp="9chq1su2vih5">
                  <span className="border border-emerald-300/40 px-2 py-1 text-[10px] font-bold uppercase text-emerald-200" data-id="element-20" data-mp="9bggxtwmh622">
                    {value} — Free today
                  </span>
                  <h3 className="mt-4 text-lg font-bold text-white" data-id="element-21" data-mp="2u0dzetvwmq3f">{title}</h3>
                  <p className="mt-2 text-sm font-medium leading-relaxed text-slate-300" data-id="element-22" data-mp="2z1thqe6p6ii4">{description}</p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}